import { c as _c } from "react/compiler-runtime";
import { isAmexOffer } from '@cc-shopping/utils/offers';
import { Typography } from '@mui/material';
import { useCreditCardCompareOfferContext } from '../../OfferContext';
import { CommonApprovalOdds } from './CommonApprovalOdds';
import { DesktopContainer } from './Desktop.container';
export function RecommendedCreditScoreDesktop() {
  const $ = _c(5);
  const {
    offer
  } = useCreditCardCompareOfferContext();
  const isAmexCard = isAmexOffer(offer);
  const t0 = isAmexCard ? "Recommended Credit" : "Recommended Credit Score";
  let t1;
  if ($[0] !== t0) {
    t1 = <Typography fontSize="14px" fontWeight={700} mb={3} ml={3}>{t0}</Typography>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CommonApprovalOdds />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <DesktopContainer>{t1}{t2}</DesktopContainer>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}